<template>
  <generic-modal :title="modal_title" ref="generic_modal">
    <div class="columns is-multiline">
      <!-- Name -->
      <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("name") }} *</label>
          <div class="control">
            <input
              v-model="form.name"
              class="input"
              :class="{ 'is-danger': error.name }"
              type="text"
              :placeholder="$t('enter position name')"
            />
          </div>
          <p v-if="error.name" class="help is-danger">{{ error.name }}</p>
        </div>
      </div>

      <!-- Status -->
      <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("status") }}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="form.status">
                <option value="active">{{ $t("active") }}</option>
                <option value="inactive">{{ $t("inactive") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Description -->
      <div class="column is-12">
        <div class="field">
          <label class="label">{{ $t("description") }}</label>
          <div class="control">
            <textarea
              v-model="form.description"
              class="textarea"
              :placeholder="$t('enter position description')"
              rows="3"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Min Salary -->
      <div class="column is-6" v-if="form.settings">
        <div class="field">
          <label class="label">{{ $t("min salary") }}</label>
          <div class="control">
            <input
              v-model="form.settings.min_salary"
              class="input"
              type="number"
              step="0.01"
              min="0"
              :placeholder="$t('enter minimum salary')"
            />
          </div>
        </div>
      </div>
      <!-- Max Salary -->
      <div class="column is-6" v-if="form.settings">
        <div class="field">
          <label class="label">{{ $t("max salary") }}</label>
          <div class="control">
            <input
              v-model="form.settings.max_salary"
              class="input"
              type="number"
              step="0.01"
              min="0"
              :placeholder="$t('enter maximum salary')"
            />
          </div>
        </div>
      </div>
      <!-- Responsibilities -->
      <div class="column is-12" v-if="form.settings">
        <div class="field">
          <label class="label">{{ $t("responsibilities") }}</label>
          <div class="control">
            <textarea
              v-model="form.settings.responsibilities"
              class="textarea"
              :placeholder="$t('enter responsibilities')"
              rows="4"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- Requirements -->
      <div class="column is-12" v-if="form.settings">
        <div class="field">
          <label class="label">{{ $t("requirements") }}</label>
          <div class="control">
            <textarea
              v-model="form.settings.requirements"
              class="textarea"
              :placeholder="$t('enter requirements')"
              rows="4"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Messages -->
    <div class="notification is-danger" v-if="error_message">
      {{ error_message }}
    </div>

    <!-- Footer with buttons using v-slot pattern -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save_position"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-check" :class="{ 'fa-spin': loading }"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import {
  generate_error_message_text,
  del,
  post,
  put,
  get,
  success_message,
  error_message,
} from "@/utils";

export default {
  name: "PositionModal",
  components: {
    GenericModal,
  },
  data() {
    return {
      loading: false,
      editing_uuid: null,
      collaborators: [],
      error_message: "",
      form: {
        name: "",
        description: "",
        settings: {
          min_salary: "",
          max_salary: "",
          responsibilities: "",
          requirements: "",
        },
        status: "active",
      },
      error: {},
    };
  },
  computed: {
    modal_title() {
      return this.editing_uuid
        ? this.$t("edit position")
        : this.$t("new position");
    },
    is_form_invalid() {
      return !this.form.name;
    },
  },
  mounted() {
    // this.load_collaborators();
  },
  methods: {
    show_modal(uuid = null) {
      this.editing_uuid = uuid;
      this.set_initial_state();

      if (uuid) {
        this.load_position(uuid);
      }

      this.$refs.generic_modal.show_modal();
    },
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },
    set_initial_state() {
      this.form = {
        name: "",
        description: "",
        settings: {
          min_salary: "",
          max_salary: "",
          responsibilities: "",
          requirements: "",
        },
        status: "active",
      };
      this.error = {};
      this.error_message = "";
    },
    // load_collaborators() {
    //   get("/personal/collaborator/catalog")
    //     .then((collaborators) => {
    //       this.collaborators = collaborators;
    //     })
    //     .catch((error) => {
    //       console.error("Error loading collaborators:", error);
    //       this.error_message = generate_error_message_text(error);
    //     });
    // },
    load_position(uuid) {
      get("/staff/position", { uuid: uuid })
        .then((position) => {
          this.form = position;
        })
        .catch((error) => {
          console.error("Error loading position:", error);
          this.error_message = generate_error_message_text(error);
        });
    },
    save_position() {
      if (this.is_form_invalid) {
        error_message(this.$t("please fill required fields"));
        return;
      }

      this.loading = true;
      this.error = {};
      this.error_message = "";

      let payload = { ...this.form };

      if (this.editing_uuid) {
        payload.uuid = this.editing_uuid;
        post("/staff/position", payload)
          .then(() => {
            let message = this.$t("position updated successfully");
            success_message(message);
            this.$emit("success");
            this.close_modal();
          })
          .catch((error) => {
            console.error("Error saving position:", error);
            this.error_message = generate_error_message_text(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        put("/staff/position", payload)
          .then(() => {
            let message = this.$t("position created successfully");
            success_message(message);
            this.$emit("success");
            this.close_modal();
          })
          .catch((error) => {
            console.error("Error saving position:", error);
            this.error_message = generate_error_message_text(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
